import * as $ from "jquery";
import * as Configuration from "../../../../../src/shared/xp/config";

const IMAGE:string = "image";

interface ImageCopyResponseItem {
    status: string; // really should be an enum with the possible values.
    statusMsg: string;
    imageId: string;
}

interface ImageCopyResponse {
    [s: string]: ImageCopyResponseItem;
}

// replace image_ids in an experienceModel object given the map from the /cms/ api
const replaceImageIdsGivenMap = (experienceModel:Backbone.Model, imageIdsMap: ImageCopyResponse): Backbone.Model => {
    if (Object.keys(imageIdsMap) && Object.keys(imageIdsMap).length > 0) {
        return _replaceIds(experienceModel, imageIdsMap);
    }
    return experienceModel;
};

const  _onlyUnique = (value: string, index: number, self: Array<string>): boolean => {
    return self.indexOf(value) === index;
};

// given an experienceModel return all of the image_ids contained within it.
const getImageIds = (experienceModel:Backbone.Model): Array<string> => {
    let experienceImagesIds = [];
    const backgroundScene = experienceModel.get("backgroundScene");
    const overlayScene = experienceModel.get("overlayScene");
    const allScenes = [
        ...(experienceModel.get("scenes") as Backbone.Collection).toArray(),
    ];
    if (backgroundScene) {
        allScenes.push(backgroundScene);
    }
    if (overlayScene) {
        allScenes.push(overlayScene);
    }

    allScenes.forEach((scene) => {
        const imageWidgets = scene.get("widgets").filter((widget) => {
            return widget.get("type") === IMAGE && widget.has("imageId");
        });

        const imageWidgetIds = imageWidgets.map((widget) => widget.get("imageId"));

        experienceImagesIds = [...experienceImagesIds, ...imageWidgetIds];
    });

    return experienceImagesIds.filter(_onlyUnique); // uniq!
};

// here we need to walk the document and replace all instances of the image_ids
const _replaceIds = (experienceModel:Backbone.Model, output: ImageCopyResponse): Backbone.Model => {
    const clonedExperienceModel = experienceModel;
    const scenes = clonedExperienceModel.get("scenes") as Backbone.Collection;
    const swappedScenes = scenes.toArray().map((scene: Backbone.Model) => swapImageIdsForScene(scene, output));
    clonedExperienceModel.set("scenes", swappedScenes);

    const backgroundScene = clonedExperienceModel.get("backgroundScene");
    const swappedBackgroundScene = swapImageIdsForScene(backgroundScene, output);
    clonedExperienceModel.set("backgroundScene", swappedBackgroundScene);

    const overlayScene = clonedExperienceModel.get("overlayScene");
    const swappedOverlayScene = swapImageIdsForScene(overlayScene, output);
    clonedExperienceModel.set("overlayScene", swappedOverlayScene);

    return clonedExperienceModel;
};

const swapImageIdsForScene = (scene: Backbone.Model, output: ImageCopyResponse): Backbone.Model => {
    if (scene && scene.get("widgets")) {
        const widgetModels = (scene.get("widgets") as Backbone.Collection).toArray();
        const swappedWidgetModels = widgetModels.map((widget: Backbone.Model) => {
            if(widget.get("type") === IMAGE && widget.has("imageId")) {
                const imageId = widget.get("imageId");
                // when you have fewer scenes than breakpoints then you go can go through again with the same experience
                // you have already swapped, and you'll get a miss on the map
                // check for this case and know we already did the image_id swap, just return the widget
                if (output[imageId]) {
                    const {imageId: newImageId} = output[imageId];
                    const newImageUrl = widget.get("imageUrl").replace(imageId, newImageId);
                    const newSrc = widget.get("src").replace(imageId, newImageId);
                    widget.set("imageId", newImageId);
                    widget.set("imageUrl", newImageUrl);
                    widget.set("src", newSrc);
                }
            }

            return widget;
        });
        scene.set("widgets", swappedWidgetModels);
    }

    return scene;
};

// this function is synchronous because calling it on the same images at the same time will
// cause some duplication in the dashboard
const getImageIdsMap = (imageIds:Array<string>): JQuery.jqXHR<ImageCopyResponse> => {
    const url = `${Configuration.default.proxyUrl}/cms/api/images/copy`;
    const options = {
        url,
        async: false,
        type: "PUT",
        data: JSON.stringify(imageIds),
        contentType: "application/json; charset=utf-8"
    };
    return $.ajax(options);
};

export default {getImageIds, getImageIdsMap, replaceImageIdsGivenMap};



// WEBPACK FOOTER //
// ./src/editor/ui/settings/export/ExportUtilities.ts